import { render, staticRenderFns } from "./CTASection.vue?vue&type=template&id=d45164dc&scoped=true"
import script from "./CTASection.vue?vue&type=script&lang=js"
export * from "./CTASection.vue?vue&type=script&lang=js"
import style0 from "./CTASection.vue?vue&type=style&index=0&id=d45164dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45164dc",
  null
  
)

export default component.exports